import { render } from "./SidemenuIcon.vue?vue&type=template&id=65505a63"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__